export const state = () => ({
  title: null,
  currentStep: 0,
  totalSteps: 99,
  modules: [
    {
      name: 'About Yourself',
      description: 'A few basic details about you.',
      duration: [2, 4],
      totalSteps: 5,
      steps: ['name', 'date-of-birth', 'address', 'partner', 'phone'],
    },
    {
      name: 'Guardians',
      displayName: 'Family',
      description: 'Who should look after your pets and children.',
      duration: [2],
      totalSteps: 6,
      steps: [
        'your-children',
        'primary',
        'backup',
        'your-pets',
        'pet-guardians',
        'pet-care-fund',
      ],
    },
    {
      name: 'Executors',
      description: 'Appoint someone to execute your wishes.',
      duration: [4],
      totalSteps: 4,
      steps: ['', 'options', 'primary', 'backup'],
    },
    {
      name: 'Estate',
      description: 'Decide how your inheritance is split.',
      duration: [4],
      totalSteps: 8,
      steps: [
        '',
        'beneficiaries',
        'distribution',
        'backup-beneficiaries',
        'backup-distribution',
      ],
    },
    {
      name: 'Gifts',
      description: 'Leave a gift to a specific beneficiary.',
      duration: [1, 5],
      totalSteps: 2,
      steps: [''],
    },
    {
      name: 'Assets',
      description: 'List the key assets within your estate.',
      duration: [2, 3],
      totalSteps: 4,
      steps: ['', 'asset-notes', 'liabilities', 'liability-notes'],
    },
    {
      name: 'Funeral',
      description: 'Leave notes about your funeral wishes.',
      duration: [2, 3],
      totalSteps: 4,
      steps: ['', 'type', 'location', 'other-requests'],
    },
  ],
  poaModules: [
    {
      name: 'About Yourself',
      description: 'A few basic details about you.',
      duration: [1, 2],
      totalSteps: 1,
      steps: [''],
    },
    {
      name: 'Financial',
      description: 'Appoint someone to make financial decisions for you.',
      duration: [2, 5],
      totalSteps: 2,
      steps: ['', 'primary', 'substitutes', 'spending', 'limitations'],
    },
    {
      name: 'Medical',
      description: 'Appoint someone to make medical decisions for you.',
      duration: [2, 5],
      totalSteps: 2,
      steps: ['', 'primary', 'substitutes', 'spending', 'limitations'],
    },
  ],
});

export const getters = {
  title: (state) => state.title,
  currentStep: (state) => state.currentStep,
  totalSteps: (state) => state.totalSteps,
  modules: (state) => state.modules,
  poaModules: (state) => state.poaModules,
};

export const mutations = {
  title(state, value) {
    state.title = value;
  },
  currentStep(state, value) {
    state.currentStep = value;
  },
  totalSteps(state, value) {
    state.totalSteps = value;
  },
};

export const actions = {
  setTitle({ commit }, value) {
    commit('title', value);
  },
  setCurrentStep({ commit }, value) {
    commit('currentStep', value);
  },
  setTotalSteps({ commit }, value) {
    commit('totalSteps', value);
  },
};
